/**
 * 지식공유 참여 GTM 이벤트 파라미터 상수 (click_join_instructor, click_join_instructor_content)
 */

export const JOIN_INSTRUCTOR_SPOTS = {
  HERO: 'hero',
  SHARE_METHOD: 'share_method',
  FINAL_CTA: 'final_cta',
} as const;
export type JoinInstructorSpot = (typeof JOIN_INSTRUCTOR_SPOTS)[keyof typeof JOIN_INSTRUCTOR_SPOTS];

export const JOIN_INSTRUCTOR_CONTENT_TYPES = {
  SHARE_METHOD: 'share_method',
  INTERVIEW_LINK: 'interview_link',
  GUIDE_DOCS: 'guide_docs',
} as const;
export type JoinInstructorContentType =
  (typeof JOIN_INSTRUCTOR_CONTENT_TYPES)[keyof typeof JOIN_INSTRUCTOR_CONTENT_TYPES];

/** content_type === 'share_method' 일 때 content_name 허용값 */
export const SHARE_METHOD_CONTENT_NAMES = {
  ON: 'on',
  CHALLENGE: 'challenge',
  MENTORING: 'mentoring',
  CLIP: 'clip',
} as const;
export type ShareMethodContentName =
  (typeof SHARE_METHOD_CONTENT_NAMES)[keyof typeof SHARE_METHOD_CONTENT_NAMES];
